import React, { useEffect, useState, useRef, useCallback } from "react";
import { Toast } from "primereact/toast";
import { InputText } from "primereact/inputtext";
import { RadioButton } from "primereact/radiobutton";
import { Button } from "primereact/button";
import { InputTextarea } from "primereact/inputtextarea";
import { InputNumber } from "primereact/inputnumber";
import { Dropdown } from "primereact/dropdown";
import { Calendars } from "../../../components/Calendar/Calendar";
import { DialogConfirm, DialogDelete, DialogConfirm_2 } from "../../../components/DialogService/DialogService";
import { FooterButtonCustomLabel, FooterButtonSigle, FooterButtonSuccess } from "../../../components/FooterButton/FooterButton";
import { Loading } from "../../../components/Loading/Loading";
import { validateInputText, validateInputTextCus } from "../../../utilities/ValidateUtil";
import { dataUserSession } from "../../../utilities/dataSession";
import { useHistory } from "react-router-dom";
import { formatDateAPI_V2, formatDateAPI } from "../../../utilities/DateUtil";
import { NullString } from "../../../utilities/NullUtil";
import * as bodyStyle from "../../../components/DataTable/ConsBodyStyle.js";
import { inputNumberColumn, actionDelColumnCusDis,inputTextColumnKeyFilter } from "../../../components/DataTable/DataTable.js";
import { currentPageReportTemplate, onPageChange, paginatorTemplate, rowsPerPageOptions } from "../../../utilities/TableUtil";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import ValidateService from "../../../components/ValidateService/ValidateService";

//SERVICE
import { contractorRequestInfo, contractorRequestUpdate } from "../../../service/100/P102Service";
import { genContractNoList, genContractRouteList, genCaseTypeList, genPipeSizeList, genUnitList, genForemanList, genCiaCameraList } from "../../../service/GEN/GenService";

export default function P102() {
    const history = useHistory();

    const toast = useRef(null);
    const [pageConf, setPageConf] = useState({ first: 0, rows: 10 });
    const [deleteDialog, setDeleteDialog] = useState(false);
    const [loading, setLoading] = useState(false);
    const [submitted, setSubmitted] = useState(false);
    const [errData, setErrData] = useState(null);
    const [dataObjTb, setDataObjTb] = useState([]);
    const [formObject, setFormObject] = useState({
        seqPk: 0,
        requestNo: "",
        displayMode: "",
        requestType: "",
        contractNo: "",
        routeNo: 0,
        locationBegin: "",
        locationEnd: "",
        locationBeginDisplay: 0,
        locationEndDisplay: 0,
        operateDate: new Date(),
        operateTimeBegin: new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate(), "09", "00"),
        operateTimeEnd: new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate(), "16", "00"),
        foreman: 0,
        supervisorReason: "",
        recordStamp: 0,
        requestCategory: "1",
        ciaCameraId: "",
    });

    const [count, setCount] = useState(0);

    // search
    const [searchData, setSearchData] = useState({
        form: "",
        requestNo: "",
        contractNo: "",
        action: "",
        userId: dataUserSession() ? dataUserSession().userId : "",
    });

    //Gen
    // DropList เลขที่สัญญา
    const [contractNo, setContractNo] = useState(null);
    const [contractNoItem, setContractNoItem] = useState([]);
    // DropList เลขที่เส้นทาง
    const [contractRoute, setContractRoute] = useState(null);
    const [contractRouteItem, setContractRouteItem] = useState([]);
    // DropList ลักษณะงาน
    const [caseTypeListItem, setCaseTypeListItem] = useState([]);
    // DropList ขนาด
    const [pipeSizeListItem, setPipeSizeListItem] = useState([]);
    // DropList หน่วย
    const [unitListItem, setUnitListItem] = useState([]);
    // DropList หัวหน้างาน
    const [foreMenList, setForeMenList] = useState(null);
    const [foreMenListItem, setForeMenListItem] = useState([]);
    //DropList กล้อง CIA
    const [ciaCameraList, setciaCameraList] = useState(null);
    const [ciaCameraListItem, setciaCameraListItem] = useState([]); 

    //Dialog
    const [confirmDialog, setConfirmDialog] = useState(false);
    const [dialogOption, setdialogOption] = useState({
        header: "",
        content: "",
        onConfirm: () => { },
        onCancle: () => { },
        footerBtn: () => { },
    });

    const [confirmDialog_2, setConfirmDialog_2] = useState(false);
    const [dialogOption_2, setdialogOption_2] = useState({
        header: "",
        content: "",
        onConfirm: () => { },
        onCancle: () => { },
        footerBtn: () => { },
    });

    // count btn save
    const [countBtnSave, setCountBtnSave] = useState(0);

    useEffect(() => {
        if (dataUserSession()) {
            if (history.location.state) {
                setSearchData({ ...searchData, ...history.location.state, userId: dataUserSession().userId });
            } else {
                history.push("/100");
            }
        } else {
            history.push("/login");
        }
    }, []);

    useEffect(() => {
        if (searchData.form === "100") {
            getDataP102();
        }
        getConstactNo();
        getCaseTypeList();
        getPipeSizeList();
        getUnitList();
        getCiaCameraList({ requestNo: searchData.requestNo });
    }, [searchData]);

    useEffect(() => {
        setForeMenList(formObject.foreman);
    }, [foreMenListItem]);

    useEffect(() => { }, [dataObjTb]);

    const validation = (object) => {
        if (object.contractNo === "" || object.routeNo === 0 || object.caseType === "" || object.locationEnd < object.locationBegin || object.operateDate === "" || object.operateTimeBegin === "" || object.operateTimeEnd === "" || object.foreman === 0) {
            setSubmitted(true);
            return false;
        } else {
            setSubmitted(false);
            return true;
        }
    };

    const getConstactNo = () => {
        const req = { userId: dataUserSession().userId };

        genContractNoList(req).then(
            (res) => {
                setLoading(false);
                if (res.status === 200) {
                    let arr = [];
                    res.data.map((item, index) => {
                        if (item.contractNo !== null) arr.push({ name: item.contractNo, code: item.seqPk });
                    });
                    setContractNoItem(arr);
                } else {
                    showMessages("error", `เกิดข้อผิดพลาด `, `ไม่พบข้อมูล`);
                }
            },
            function (err) {
                if (err.response && err.response.data.status === 401) {
                    alert(JSON.stringify("เนื่องจาก Authorized หมดอายุ กรุณาเข้าสู่ระบบใหม่"));
                    window.location.href = "/login";
                }
                setLoading(false);
            }
        );
    };
    const getCaseTypeList = () => {
        const req = { userId: dataUserSession().userId };

        genCaseTypeList(req).then(
            (res) => {
                setLoading(false);
                if (res.status === 200) {
                    let arr = [];
                    res.data.map((item, index) => {
                        if (item.caseTypeDesc !== null) arr.push({ name: item.caseTypeDesc, code: item.caseTypeCode });
                    });

                    setCaseTypeListItem(arr);
                } else {
                    showMessages("error", `เกิดข้อผิดพลาด `, `ไม่พบข้อมูล`);
                }
            },
            function (err) {
                setLoading(false);
                setErrData(err);
            }
        );
    };

    const getPipeSizeList = () => {
        const req = { userId: dataUserSession().userId };

        genPipeSizeList(req).then(
            (res) => {
                setLoading(false);
                if (res.status === 200) {
                    let arr = [];
                    res.data.map((item, index) => {
                        if (item.sizeDesc !== null) arr.push({ name: item.sizeDesc, code: item.sizeCode });
                    });
                    setPipeSizeListItem(arr);
                } else {
                    showMessages("error", `เกิดข้อผิดพลาด `, `ไม่พบข้อมูล`);
                }
            },
            function (err) {
                setLoading(false);
                setErrData(err);
            }
        );
    };
    const getUnitList = () => {
        const req = { userId: dataUserSession().userId };

        genUnitList(req).then(
            (res) => {
                setLoading(false);
                if (res.status === 200) {
                    let arr = [];
                    res.data.map((item, index) => {
                        if (item.unitDesc !== null) arr.push({ name: item.unitDesc, code: item.unitCode });
                    });
                    setUnitListItem(arr);
                } else {
                    showMessages("error", `เกิดข้อผิดพลาด `, `ไม่พบข้อมูล`);
                }
            },
            function (err) {
                setLoading(false);
                setErrData(err);
            }
        );
    };
    const getForemanList = (contractNo) => {
        const req = { userId: dataUserSession().userId, contractNo: contractNo };

        genForemanList(req).then(
            (res) => {
                setLoading(false);
                if (res.status === 200) {
                    let arr = [];
                    res.data.map((item, index) => {
                        if (item.foremanFullName !== null) arr.push({ name: item.foremanFullName, code: item.foremanId });
                    });

                    setForeMenListItem(arr);
                    //set foreMenList
                } else {
                    showMessages("error", `เกิดข้อผิดพลาด `, `ไม่พบข้อมูล`);
                }
            },
            function (err) {
                setLoading(false);
                setErrData(err);
            }
        );
    };

    const getDataP102 = () => {
        setLoading(true);

        const req = {
            requestNo: searchData.requestNo,
            userId: searchData.userId,
        };
        contractorRequestInfo(req).then(
            (res) => {
                setLoading(false);
                if (res.status === 200) {
                    if (res.data.length > 0 && res.data[0] !== null) {
                        let temp = [];
                        let index = 0;
                        res.data.forEach((element) => {
                            temp.push({
                                ...element,
                                caseQuantity: element.caseQuantity === null ? "" : element.caseQuantity.toString().replace(".","+"),
                                index: index,
                            });
                            index++;
                        });

                        const valiData = NullString(temp[0].caseType) !== "" || NullString(temp[0].casePipeSize) !== "" || NullString(temp[0].caseQuantity) !== "" || NullString(temp[0].caseUnit) !== "";

                        if (valiData) {
                            setDataObjTb(temp);
                        }

                        const _data = res.data[0];
                       

                        setFormObject({
                            ...formObject,
                            userId: searchData.userId,
                            requestNo: searchData.requestNo,
                            contractNo: _data.contractNo,
                            displayMode: _data.displayMode,
                            operateDate: _data.operateDate,
                            routeNo: _data.routeNo,
                            foreman: _data.foremanId,
                            locationBegin: _data.locationBegin == null ? "" : _data.locationBegin.toString().replace(".","+"),
                            locationEnd: _data.locationEnd == null ? "" : _data.locationEnd.toString().replace(".","+"),
                            locationBeginDisplay: _data.locationBeginDisplay,
                            locationEndDisplay: _data.locationEndDisplay,
                            operateTimeBegin: _data.operateTimeBegin,
                            operateTimeEnd: _data.operateTimeEnd,
                            requestType: _data.requestType,
                            supervisorReason: _data.supervisorReason,
                            recordStamp: _data.recordStamp,
                            requestCategory: _data.requestCategory,
                            ciaCameraId : _data.ciaCameraId,
                        });

                        // setDefault contractor no
                        setContractNo(_data.contractNo);

                        // setDefault contractor route
                        setContractRoute(_data.routeNo);
                        getContractRouteList(_data.contractNo);

                        // get contract
                        getForemanList(_data.contractNo);
                        
                        setciaCameraList(_data.ciaCameraId);


                    }
                } else {
                    showMessages("error", `เกิดข้อผิดพลาด `, `ไม่พบข้อมูล`);
                }
            },
            function (err) {
                setLoading(false);
                setErrData(err);
            }
        );
    };
    const getContractRouteList = (contractNo) => {
        const req = { userId: dataUserSession().userId, contractNo: contractNo };
        genContractRouteList(req).then(
            (res) => {
                setLoading(false);

                let arr = [];
                res.data.map((item, index) => {
                    if (item.routeName !== null) arr.push({ name: item.routeName, code: item.routeNo });
                });
                setContractRouteItem(arr);
                if (res.status === 200) {
                } else {
                    showMessages("error", `เกิดข้อผิดพลาด `, `ไม่พบข้อมูล`);
                }
            },
            function (err) {
                setLoading(false);
                setErrData(err);
            }
        );
    };

    //CIA
    const getCiaCameraList = (data) => {
        const req = {
            requestNo: data.requestNo,
            userId: dataUserSession().userId,
        };
        genCiaCameraList(req).then((res) => {
            setLoading(false);
            if (res.status === 200) {
                let arr = [];
                res.data.map((item, index) => {
                    arr.push({
                        ...item,
                    });
                });
                setciaCameraListItem(arr);
            } else {
                showMessages("error", `เกิดข้อผิดพลาด `, `ไม่พบข้อมูล`);
            }

        },
            function (err) {
                setLoading(false);
                setErrData(err);
            })
    };

    const setAction = () => {
        if (searchData.form === "100") {
            return "U";
        } else if (searchData.form === "101") {
            if (searchData.requestNo !== "") {
                return "U";
            } else {
                return "A";
            }
        }
    };

    const contentDialog = (arr) => {
        return (
            <div style={{ textAlign: "center" }}>
                <i className="pi pi-check-circle" style={{ fontSize: "larger", color: "green" }}></i>
                <span style={{ marginLeft: "5px" }}>{arr[0]}</span>
                <p style={{ marginLeft: "5px" }}>{arr[1]}</p>
            </div>
        );
    };

    const submitForm = (act) => {
        setConfirmDialog(false);
        if (validation(formObject)) {
            if (formObject.requestCategory === "1") {
                if (dataObjTb.length > 0) {
                    let chkTb = true;
                    let str = "";
                    let num = 1;
                    for (let index = 0; index < dataObjTb.length; index++) {
                        if (dataObjTb[index].caseType !== "") {
                            str += "" + dataObjTb[index].caseType;
                        }

                        if (dataObjTb[index].casePipeSize !== "") {
                            str += "%" + dataObjTb[index].casePipeSize;
                        }

                        if (dataObjTb[index].caseQuantity !== "") {
                            str += "%" + dataObjTb[index].caseQuantity.replace("+",".");
                        }

                        if (dataObjTb[index].caseUnit !== "") {
                            str += "%" + dataObjTb[index].caseUnit;
                        }

                        if (num < dataObjTb.length) {
                            str += "|";
                        }
                        if (NullString(dataObjTb[index].caseType) === "" || NullString(dataObjTb[index].casePipeSize) === "" || NullString(dataObjTb[index].caseQuantity) === "" || NullString(dataObjTb[index].caseUnit) === "") {
                            chkTb = false;
                        }
                        num++;
                    }

                    setLoading(true);
                    if (chkTb) {
                        handlerSubmit(act, str);
                    } else {
                        setLoading(false);
                        showMessages("error", `เกิดข้อผิดพลาด : กรุณาระบุลักษณะงาน ขนาด ปริมาณ หน่วย`, "");
                    }
                } else {
                    showMessages("error", `เกิดข้อผิดพลาด : เพิ่มรายการใหม่ `, "");
                }
            } else {
                handlerSubmit(act);
            }
        } else {
        }
    };

    const handlerSubmit = (act, str = "") => {
  
        const req = {
            actionCode: act === "INS" ? setAction() : act,
            contractNo: formObject.contractNo,
            foremanId: formObject.foreman,
            locationBegin: parseFloat(formObject.locationBegin.replace("+",".")),
            locationEnd: parseFloat(formObject.locationEnd.replace("+",".")),
            operateTimeBegin: formObject.operateTimeBegin === "" ? "" : formatDateAPI_V2(formObject.operateTimeBegin, true),
            operateTimeDate: formatDateAPI(formObject.operateDate, false),
            operateTimeEnd: formObject.operateTimeEnd === "" ? "" : formatDateAPI_V2(formObject.operateTimeEnd, true),
            requestNo: searchData.requestNo,
            routeNo: formObject.routeNo,
            stringData: str,
            userId: searchData.userId,
            recordStamp: formObject.recordStamp,
            requestCategory: formObject.requestCategory,
            ciaCameraId: formObject.ciaCameraId === null ? "" : formObject.ciaCameraId,
        };

        contractorRequestUpdate(req).then(
            (res) => {
                setLoading(false);
                if (res.length > 0) {
                    const alert = res[0];
                    if (alert.statusText.split(" ")[1] !== undefined) setSearchData({ ...searchData, requestNo: alert.statusText.split(" ")[1] });
                    getDataP102();
                    if (act === "D") {
                        setdialogOption({
                            ...dialogOption,
                            header: "",
                            content: alert.statusText,
                            footerBtn: () => footerButtonSingle_2(),
                        });
                        setConfirmDialog({ open: true });
                    } else if (act === "S") {
                        setdialogOption({
                            ...dialogOption,
                            header: "",
                            content: alert.statusCode === "C" ? "ส่งผู้คุมงานเรียบร้อยแล้ว" : alert.statusText,
                            footerBtn: () => footerButtonSingle_2(),
                        });
                        setConfirmDialog({ open: true });
                    } else {
                        setCountBtnSave(1);
                        const _a = alert.statusText.split("-");
                        if (_a.length > 1) {
                            setdialogOption_2({
                                ...dialogOption_2,
                                header: "",
                                content: contentDialog(_a),
                                footerBtn: () => footerButtonSingle_4(), //footerButtonSingle()
                            });
                            setConfirmDialog_2({ open: true });
                        } else {
                            setdialogOption({
                                ...dialogOption,
                                header: "",
                                content: _a[0],
                                footerBtn: () => footerButtonSingle_3(), //footerButtonSingle()
                            });
                            setConfirmDialog({ open: true });
                        }
                    }
                }
            },
            function (err) {
                if (err.response && err.response.data.status === 401) {
                    alert("เนื่องจาก Authorized หมดอายุ กรุณาเข้าสู่ระบบใหม่");
                    window.location.href = "/login";
                } else {
                    showMessages("error", `เกิดข้อผิดพลาด : ${err} `, "");
                }
                setLoading(false);
            }
        );
    };
    const footerButton = () => {
        const handlerDeleteData = () => {
            const _filter = dataObjTb.filter((data) => data.index !== deleteDialog.data.index);

            _filter.map((t, i) => {
                return (_filter[i].index = i);
            });

            setDataObjTb(_filter);
            if (dataObjTb.length === 1) {
                setTimeout(() => {
                    // handlerAddRowTable(_filter);
                }, 1000);
            }
            setDeleteDialog(false);
        };

        return <FooterButtonCustomLabel labelCon="ยืนยัน" lableCan="ยกเลิก" onClickOk={() => handlerDeleteData()} onClickCancle={() => setDeleteDialog(false)} />;
    };
    const showMessages = (severity = "error", summary = "", detail = "") => {
        toast.current.show({ severity: severity, summary: summary, detail: detail, life: 10000 });
    };
    const footerButtonCon = (act) => {
        return <FooterButtonCustomLabel labelCon="ยืนยัน" lableCan="ยกเลิก" onClickOk={() => submitForm(act)} onClickCancle={() => setConfirmDialog(false)} />;
    };

    const footerButtonSingle_2 = () => {
        return (
            <FooterButtonSigle
                btnLabel="ปิด"
                onClick={() => {
                    handlerBackPage();

                    setConfirmDialog({ open: false });
                }}
            />
        );
    };
    const footerButtonSingle_3 = () => {
        return (
            <FooterButtonSigle
                btnLabel="ปิด"
                onClick={() => {
                    // handlerBackPage();

                    setConfirmDialog({ open: false });
                }}
            />
        );
    };

    const footerButtonSingle_4 = () => {
        return (
            <FooterButtonSigle
                btnLabel="ปิด"
                onClick={() => {
                    // handlerBackPage();

                    setConfirmDialog_2({ open: false });
                }}
            />
        );
    };

    const handlerAddRowTable = (d) => {
        const data = { index: d.length, seqPK: dataObjTb.length + 1, nature: "", size: "", amount: "", unit: "", casePipeSize: "", caseQuantity: "", caseType: "", caseUnit: "" };
        setDataObjTb((current) => [...current, data]);
    };
    const disableInput = () => {
        // return formObject.requestNo !== "" || formObject.displayMode === "Y" ? true : false;
        return formObject.displayMode === "Y" ? true : false;
    };
    const headerLabel = <span className="hidden-responsive">เพิ่มรายการใหม่</span>;
    const actionBodyDel = (rowData) => setDeleteDialog({ open: true, data: rowData });

    const headlerInpusText = useCallback(
        (e, rowData, inputname) => {
            const objIndex = dataObjTb.findIndex((obj) => obj.index === rowData.index);
            dataObjTb[objIndex][inputname] = e;
            setCount(count + 1);
            setDataObjTb(dataObjTb);
        },
        [dataObjTb, count]
    );

    const handlerStateRowData = useCallback(
        (e, rowData, dropName) => {
            const objIndex = dataObjTb.findIndex((obj) => obj.index === rowData.index);
            dataObjTb[objIndex][dropName] = e;
            setCount(count + 1);
            setDataObjTb(dataObjTb);
        },
        [dataObjTb, count]
    );

    const LlistBoxColumn = (rowData, checkColumn, listboxValue, setListboxValue, mandatory, titleShow, dropName) => {
        let data = { ...rowData };
        let datavalue = (data["checkColumn"] = checkColumn);
        return (
            <React.Fragment>
                <span className="p-column-title">{titleShow}</span>
                <Dropdown
                    id={`${dropName}_${data.index}`}
                    value={listboxValue.length > 0 ? listboxValue[data.index][dropName] : ""}
                    className={mandatory}
                    onChange={(e) => {
                        setListboxValue(e.value, rowData, dropName);
                    }}
                    options={datavalue}
                    optionLabel="name"
                    optionValue="code"
                    style={{ width: "100%" }}
                    disabled={disableInput()}
                />
            </React.Fragment>
        );
    };

    const header = (
        <div className="table-header">
            <Button className="p-button p-button-success btn-hidden-responsive " label={headerLabel} icon="pi pi-plus" onClick={() => handlerAddRowTable(dataObjTb)} autoFocus disabled={disableInput()} />
            <span className="p-input-icon-left span-responsive"></span>
        </div>
    );

    // setting Dialog
    const handlerSettingDialogConfirm = (key) => {
        switch (key) {
            case "D_CON_INS":
                setdialogOption({
                    ...dialogOption,
                    header: "",
                    content: "คุณต้องการบันทึกข้อมูลหรือไม่",
                    footerBtn: () => footerButtonCon("INS"),
                    onCancle: () => setConfirmDialog(false),
                });
                break;

            case "S":
                setdialogOption({
                    ...dialogOption,
                    header: "",
                    content: "ต้องการส่งข้อมูลให้ผู้คุมงานหรือไม่",
                    footerBtn: () => footerButtonCon("S"),
                    onCancle: () => setConfirmDialog(false),
                });
                break;

            case "D":
                setdialogOption({
                    ...dialogOption,
                    header: "",
                    content: "ต้องการยกเลิกใบแจ้งฯนี้หรือไม่",
                    footerBtn: () => footerButtonCon("D"),
                    onCancle: () => setConfirmDialog(false),
                });
                break;

            default:
                break;
        }

        setConfirmDialog({ open: true });
    };

    const handlerBackPage = () => {
        history.push(`/100`);
        // history.push(`/${searchData.form}`);
    };

    const emptyClick = () => {
        return <div onClick={() => handlerAddRowTable(dataObjTb)}>ไม่มีรายการ</div>;
    };

    const disBtnSave = () => {
        return formObject.displayMode === "Y" || countBtnSave !== 0 ? true : false;
    };

    const btnDis = () => {
        if (formObject.displayMode === "Y") {
            return true;
        } else {
            if (countBtnSave === 0) {
                return true;
            } else {
                return false;
            }
        }
    };

    return (
        <>
            <Loading loading={loading} />
            <ValidateService err={errData} setErr={setErrData} />
            <div className="p-grid crud-demo">
                <Toast ref={toast} position="top-right" />
                <div className="p-col-12">
                    <div className="card">
                        {/* <h2 className="p-m-0">รายละเอียดใบแจ้งขอปฏิบัติงาน(งานใหม่)</h2>
                        <hr /> */}
                        <div className="p-fluid p-formgrid p-grid">
                            <div className="p-field p-col-12 p-md-4">
                                <label htmlFor="requestNo">เลขที่ใบแจ้งฯ</label>
                                <InputText id="requestNo" type="text" disabled={true} maxLength="20" value={formObject.requestNo == "" ? searchData.requestNo : formObject.requestNo} />
                            </div>
                            <div className="p-field p-col-12 p-md-4">
                                <label htmlFor="requestType">ประเภทงาน</label>
                                <InputText id="requestType" type="text" disabled={true} maxLength="100" value={searchData.requestNo === "" ? "งานใหม่" : searchData.requestTypeDesc} />
                            </div>
                        </div>
                        <div className="p-fluid p-formgrid p-grid">
                            <div className="p-field p-col-12 p-md-4">
                                <label htmlFor="contractNo">เลขที่สัญญา</label>
                                <span style={{ color: "red" }}>*</span>
                                <Dropdown
                                    id="contractNo"
                                    className={submitted && !formObject.contractNo ? "p-invalid" : ""}
                                    value={contractNo}
                                    optionValue="name"
                                    onChange={(e) => {
                                        setContractNo(e.value);
                                        getContractRouteList(e.value);
                                        getForemanList(e.value);
                                        setFormObject({ ...formObject, contractNo: e.value });
                                    }}
                                    options={contractNoItem}
                                    optionLabel="name"
                                    placeholder="เลือก เลขที่สัญญา"
                                    disabled={disableInput()}
                                    maxLength="20"
                                ></Dropdown>
                                {submitted && !formObject.contractNo && validateInputText("contractNo", "เลขที่สัญญา")}
                            </div>
                            <div className="p-field p-col-12 p-md-4">
                                <label htmlFor="routeNo">เส้นทาง</label>
                                <span style={{ color: "red" }}>*</span>
                                <Dropdown
                                    id="routeNo"
                                    className={submitted && !formObject.routeNo ? "p-invalid" : ""}
                                    value={contractRoute}
                                    optionValue="code"
                                    onChange={(e) => {
                                        setContractRoute(e.value);
                                        setFormObject({ ...formObject, routeNo: e.value });
                                    }}
                                    options={contractRouteItem}
                                    optionLabel="name"
                                    placeholder="เลือก เส้นทาง"
                                    disabled={disableInput()}
                                    maxLength="5"
                                ></Dropdown>
                                {submitted && !formObject.routeNo && validateInputText("routeNo", "เส้นทาง")}
                            </div>

                            <div className="p-field p-col-12 p-md-4">
                                <label htmlFor="routeNo">กล้อง CIA</label>
                                {/* <span style={{ color: "red" }}>*</span> */}
                                <Dropdown
                                    id="ciaCameraId"
                                   // className={submitted && !formObject.ciaCameraId ? "p-invalid" : ""}
                                    value={ciaCameraList}
                                    optionValue="cameraId"
                                    onChange={(e) => {
                                       
                                        setciaCameraList(e.value);
                                        setFormObject({ ...formObject, ciaCameraId: e.value });
                                    }}
                                    options={ciaCameraListItem}
                                    optionLabel="cameraName"
                                    placeholder="เลือก กล้อง CIA"
                                   // disabled={disableInput()}
                                    maxLength="5"
                                ></Dropdown>
                                {/* {submitted && !formObject.ciaCameraId && validateInputText("ciaCameraId", "กล้อง CIA")} */}
                            </div>
                        </div>
                        <div className="p-fluid p-formgrid p-grid">
                            <div className="p-field p-col-12 p-md-4">
                                <div className="p-field-radiobutton" style={{ marginTop: "0.45rem", marginBottom: "0.45rem" }}>
                                    <RadioButton inputId="requestCategory" name="requestCategory" value="1" onChange={(e) => setFormObject({ ...formObject, requestCategory: e.value })} checked={formObject.requestCategory === "1"} />
                                    <label htmlFor="requestCategory" style={{ marginRight: ".5rem" }}>
                                        ปฏิบัติงาน
                                    </label>
                                    <RadioButton inputId="requestCategory" name="requestCategory" value="2" onChange={(e) => setFormObject({ ...formObject, requestCategory: e.value })} checked={formObject.requestCategory === "2"} />
                                    <label htmlFor="requestCategory" style={{ marginRight: ".5rem" }}>
                                        ตรวจสอบรับงาน
                                    </label>
                                </div>
                            </div>
                        </div>
                        {formObject.requestCategory === "1" && (
                            <div className="datatable-responsive-modify">
                                <div className="card">
                                    <DataTable
                                        // ref={(el) => dt = el}
                                        value={dataObjTb}
                                        dataKey="id"
                                        paginator
                                        first={pageConf.first}
                                        rows={pageConf.rows}
                                        onPage={(e) => onPageChange(e, setPageConf)}
                                        rowsPerPageOptions={rowsPerPageOptions()}
                                        paginatorTemplate={paginatorTemplate()}
                                        currentPageReportTemplate={currentPageReportTemplate()}
                                        header={header}
                                        // globalFilter={globalFilter}
                                        emptyMessage={emptyClick()}
                                        className="p-datatable-gridlines p-datatable-sm p-datatable-responsive-modify"
                                        selectionMode="single"
                                    >
                                        <Column field="caseType" header="ลักษณะงาน" body={(e) => LlistBoxColumn(e, caseTypeListItem, dataObjTb, handlerStateRowData, "", "ลักษณะงาน", "caseType")} style={{ textAlign: "center", width: "20%" }} bodyStyle={bodyStyle.TXT_LEFT} />
                                        <Column field="casePipeSize" header="ขนาด" body={(e) => LlistBoxColumn(e, pipeSizeListItem, dataObjTb, handlerStateRowData, "", "ขนาด", "casePipeSize")} style={{ textAlign: "center", width: "20%" }} bodyStyle={bodyStyle.TXT_LEFT} />
                                        <Column
                                            field="caseQuantity"
                                            header="ปริมาณ"
                                            body={(e) => inputTextColumnKeyFilter(e, "caseQuantity", dataObjTb, headlerInpusText, "ปริมาณ", "ปริมาณ", "caseQuantity", disableInput())}
                                            style={{ textAlign: "center", width: "20%" }}
                                            bodyStyle={bodyStyle.TXT_LEFT}
                                        />
                                        <Column field="caseUnit" header="หน่วย" body={(e) => LlistBoxColumn(e, unitListItem, dataObjTb, handlerStateRowData, "", "หน่วย", "caseUnit")} style={{ textAlign: "center", width: "15%" }} bodyStyle={bodyStyle.TXT_LEFT} />
                                        <Column header="ลบรายการ" body={(e) => actionDelColumnCusDis(e, actionBodyDel, disableInput())} style={{ textAlign: "center", width: "6%" }} bodyStyle={bodyStyle.TXT_CENTER}></Column>
                                    </DataTable>
                                </div>
                            </div>
                        )}

                        {/* End List Table */}
                        <div className="p-fluid p-formgrid p-grid">
                            <div className="p-field p-col-12 p-md-4">
                                <label htmlFor="location_begin">บริเวณก่อสร้าง</label>
                                <span style={{ color: "red" }}>*</span>
                                {formObject.displayMode === "Y" ? (
                                    <InputText id="locationBeginDisplay" type="text" disabled={true} maxLength="20" value={formObject.locationBeginDisplay} />
                                ) : (

                                    <InputText
                                    id="locationBegin"
                                    className={formObject.locationBegin && !formObject.locationBegin ? "p-invalid" : ""}
                                    value={formObject.locationBegin}
                                    onChange={(e) => setFormObject({ ...formObject, locationBegin: e.target.value })}
                                    placeholder="ระบุ บริเวณก่อสร้าง"
                                    disabled={disableInput()}
                                    keyfilter={/\d|[+]/}
                                    />
                                    // <InputNumber
                                    //     id="locationBegin"
                                    //     mode="decimal"
                                    //     useGrouping={false}
                                    //     max={99999999999}
                                    //     minFractionDigits={3}
                                    //     maxFractionDigits={3}
                                    //     className={formObject.locationBegin && !formObject.locationBegin ? "p-invalid" : ""}
                                    //     value={formObject.locationBegin}
                                    //     placeholder="ระบุ บริเวณก่อสร้าง"
                                    //     disabled={disableInput()}
                                    //     onValueChange={(e) => setFormObject({ ...formObject, locationBegin: e.value })}
                                    // />
                                )}
                                {formObject.locationBegin === null && !formObject.locationBegin && validateInputText("locationBegin", "บริเวณก่อสร้าง")}
                            </div>
                            <div className="p-field p-col-12 p-md-4">
                                <label htmlFor="locationEnd">ถึง</label>{" "}
                                {formObject.displayMode === "Y" ? (
                                    <InputText id="locationEndDisplay" type="text" disabled={true} maxLength="20" value={formObject.locationEndDisplay} />
                                ) : (
                                    <InputText
                                    id="locationEnd"
                                    className={formObject.locationEnd < formObject.locationBegin ? "p-invalid" : ""}
                                    value={formObject.locationEnd}
                                    onChange={(e) => setFormObject({ ...formObject, locationEnd: e.target.value })}
                                    placeholder="ระบุ บริเวณก่อสร้าง"
                                    disabled={disableInput()}
                                    keyfilter={/\d|[+]/}
                                    />
                                    // <InputNumber
                                    //     className={formObject.locationEnd < formObject.locationBegin ? "p-invalid" : ""}
                                    //     id="locationEnd"
                                    //     mode="decimal"
                                    //     useGrouping={false}
                                    //     max={99999999999}
                                    //     minFractionDigits={3}
                                    //     maxFractionDigits={3}
                                    //     placeholder="ระบุ ถึง"
                                    //     disabled={disableInput()}
                                    //     value={formObject.locationEnd}
                                    //     onValueChange={(e) => setFormObject({ ...formObject, locationEnd: e.value })}
                                    // />
                                )}
                                {formObject.locationEnd < formObject.locationBegin ? validateInputTextCus("locationEnd", "ต้องมากกว่าหรือเท่ากับบริเวณก่อสร้าง") : ""}
                            </div>
                        </div>
                        <div className="p-fluid p-formgrid p-grid">
                            <div className="p-field p-col-12 p-md-4">
                                <label htmlFor="operateTimeBegin">วันที่เวลาออกปฏิบัติงานจาก</label>
                                <span style={{ color: "red" }}>*</span>
                                <Calendars key="operateTimeBegin" id="operateTimeBegin" value={new Date(formObject.operateTimeBegin)} onChange={(e) => setFormObject({ ...formObject, operateTimeBegin: e.target.value })} disabled={disableInput()} showTime={true} />
                                {submitted && !formObject.operateTimeBegin && validateInputText("operateTimeBegin", "วันที่เวลาออกปฏิบัติงานจาก")}
                            </div>
                            <div className="p-field p-col-12 p-md-4">
                                <label htmlFor="operateTimeEnd">วันที่เวลาออกปฏิบัติงานถึง</label>
                                <span style={{ color: "red" }}>*</span>
                                <Calendars key="operateTimeEnd" id="operateTimeEnd" value={new Date(formObject.operateTimeEnd)} onChange={(e) => setFormObject({ ...formObject, operateTimeEnd: e.target.value })} disabled={disableInput()} showTime={true} />
                                {submitted && !formObject.operateTimeEnd && validateInputText("operateTimeEnd", "วันที่เวลาออกปฏิบัติงานถึง")}
                            </div>
                        </div>
                        {/* <div className="p-fluid p-formgrid p-grid">
                            <div className="p-field p-col-12 p-md-4">
                                <label htmlFor="operateTimeBegin">ช่วงเวลาจาก</label>
                                <span style={{ color: "red" }}>*</span>
                                <InputMask id="operateTimeBegin" className={submitted && !formObject.operateTimeBegin ? "p-invalid" : ""} mask="99:99" value={formObject.operateTimeBegin} onChange={(e) => setFormObject({ ...formObject, operateTimeBegin: e.target.value })} disabled={disableInput()} />
                                {submitted && !formObject.operateTimeBegin && validateInputText("operateTimeBegin", "ช่วงเวลาจาก")}
                            </div>
                            <div className="p-field p-col-12 p-md-4">
                                <label htmlFor="operateTimeEnd">ถึง</label>
                                <span style={{ color: "red" }}>*</span>
                                <InputMask id="operateTimeEnd" mask="99:99" className={submitted && !formObject.operateTimeEnd ? "p-invalid" : ""} value={formObject.operateTimeEnd} onChange={(e) => setFormObject({ ...formObject, operateTimeEnd: e.target.value })} disabled={disableInput()} />
                                {submitted && !formObject.operateTimeEnd && validateInputText("operateTimeEnd", "ถึง")}
                            </div>
                        </div> */}
                        <div className="p-fluid p-formgrid p-grid">
                            <div className="p-field p-col-12 p-md-4">
                                <label htmlFor="foreman">หัวหน้างาน</label>
                                <span style={{ color: "red" }}>*</span>
                                <Dropdown
                                    id="foreman"
                                    className={submitted && !formObject.foreman ? "p-invalid" : ""}
                                    value={foreMenList}
                                    onChange={(e) => {
                                        setForeMenList(e.value);
                                        setFormObject({ ...formObject, foreman: e.value });
                                    }}
                                    options={foreMenListItem}
                                    optionLabel="name"
                                    optionValue="code"
                                    placeholder="เลือก หัวหน้างาน"
                                    disabled={disableInput()}
                                ></Dropdown>
                                {submitted && !formObject.foreman && validateInputText("foreman", "หัวหน้างาน")}
                            </div>
                        </div>
                        <div className="p-fluid p-formgrid p-grid">
                            <div className="p-field p-col-12 p-md-4">
                                <label htmlFor="supervisorReason">เหตุผลจากผู้ควบคุมงาน</label>
                                <InputTextarea id="supervisorReason" value={formObject.supervisorReason} rows="4" onChange={(e) => setFormObject({ ...formObject, supervisorReason: e.target.value })} disabled={true} />
                            </div>
                        </div>
                        <div className="p-grid" style={{ textAlign: "center" }}>
                            <div className="p-col-12">
                                <div className="p-grid" style={{ textAlign: "center" }}>
                                    <div className="p-col-2"></div>
                                    <div className="p-col-4">
                                        <Button
                                            className="p-button-success p-button"
                                            icon="pi pi-save"
                                            label="บันทึก"
                                            style={{ width: 170 }}
                                            onClick={() => {
                                                submitForm("INS");
                                            }}
                                            disabled={disBtnSave()}
                                        />
                                        <Button
                                            className="p-button-secondary p-button "
                                            icon="pi pi-arrow-left"
                                            label="กลับหน้าจอหลัก"
                                            // style={{ marginLeft: '5px' }}
                                            style={{ width: 170, marginLeft: "5px" }}
                                            onClick={() => handlerBackPage()}
                                        />
                                    </div>
                                    <div className="p-col-4">
                                        {/* {searchData.requestNo !== "" && ( */}
                                        <Button
                                            className="p-button-warning p-button"
                                            icon="pi pi-sign-in"
                                            label="ส่งผู้คุมงาน"
                                            // style={{ marginLeft: '5px' }}
                                            style={{ width: 170, marginLeft: "5px" }}
                                            disabled={btnDis()}
                                            onClick={() => handlerSettingDialogConfirm("S")}
                                        />
                                        {/* )} */}
                                        {/* {searchData.requestNo !== "" && ( */}
                                        <Button
                                            className="p-button-danger p-button"
                                            icon="pi pi-ban"
                                            label="ยกเลิกใบแจ้งฯ นี้"
                                            // style={{ marginLeft: '5px' }}
                                            style={{ width: 170, marginLeft: "5px" }}
                                            disabled={btnDis()}
                                            onClick={() => handlerSettingDialogConfirm("D")}
                                        />
                                        {/* )} */}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <DialogDelete visible={deleteDialog.open} header="" modal footer={footerButton()} onHide={() => setDeleteDialog(false)} textContent="คุณต้องการลบข้อมูล ใช่หรือไม่ ?" />
                    <DialogConfirm visible={confirmDialog.open} header={dialogOption.header} modal footer={dialogOption.footerBtn} onHide={() => setConfirmDialog(false)} textContent={dialogOption.content} />
                    <DialogConfirm_2 visible={confirmDialog_2.open} header={dialogOption_2.header} modal footer={dialogOption_2.footerBtn} onHide={() => setConfirmDialog_2(false)} textContent={dialogOption_2.content} />
                </div>
            </div>
        </>
    );
}
